import { api, api2 , apiUpload } from './ApiService';

export default class ImageService {
    
    static async get(type){
        let response =  await api2.get(`/image?type=${type}`)
        return response.data
    }

    static async create(formData){
        let response = await apiUpload.post(`/api/v1/image/create`,formData)
        return response.data
    }
    static async update(formData){
        let response = await apiUpload.post(`/api/v1/image/update`,formData)
        return response.data
    }
     static async delete(data){
        let response = await api2.post(`/api/v1/image/delete`,data)
        return response.data
    }
}


// WEBPACK FOOTER //
// ./src/service/ImageService.js